var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("multi-lang-maintain-core", {
    attrs: {
      title: "商品多语言维护",
      "button-text": "多语言维护",
      "dialog-width": "1320px",
      "biz-id": _vm.productId,
      "biz-type": "PRODUCT",
      "source-lang-code": "zh-CN",
      "load-detail": _vm.loadDetail,
      "before-save": _vm.beforeSave,
      "save-source": _vm.saveSource,
      "optional-field-keys": ["description.content"],
      maintained: _vm.maintained,
      "page-biz-ids": _vm.pageBizIds,
      "page-data-version": _vm.pageDataVersion,
    },
    on: {
      saved: function ($event) {
        return _vm.$emit("saved")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "left",
        fn: function (slotProps) {
          return [
            _c(
              "div",
              [
                _c("div", { staticClass: "panel-title" }, [
                  _vm._v("源数据（" + _vm._s(slotProps.defaultLangName) + "）"),
                ]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    staticClass: "formValidate",
                    attrs: { "label-width": "110px" },
                  },
                  [
                    _vm._l(
                      _vm.getNormalFormFieldItems(slotProps.fieldItems),
                      function (item) {
                        return _c(
                          "el-form-item",
                          {
                            key: "left_" + item.fieldKey,
                            attrs: { label: item.fieldLabel + "：" },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                value: slotProps.getSourceValue(item),
                                type: "textarea",
                                rows: 2,
                                placeholder:
                                  "请输入" + slotProps.defaultLangName,
                              },
                              on: {
                                input: function ($event) {
                                  return slotProps.setSourceValue(
                                    item.fieldKey,
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        )
                      }
                    ),
                    _vm._v(" "),
                    _vm.getSkuValueFieldItems(slotProps.fieldItems).length
                      ? _c("el-form-item", { attrs: { label: "SKU规格：" } }, [
                          _c("div", { staticClass: "sku-native-wrap" }, [
                            _c("table", { staticClass: "sku-native-table" }, [
                              _c("thead", [
                                _c(
                                  "tr",
                                  [
                                    _c("th", [_vm._v("SKU ID")]),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.getSkuAttrNameFieldItems(
                                        slotProps.fieldItems
                                      ),
                                      function (column) {
                                        return _c(
                                          "th",
                                          {
                                            key:
                                              "left_sku_col_" + column.fieldKey,
                                          },
                                          [
                                            _c("input", {
                                              staticClass: "sku-header-input",
                                              attrs: {
                                                placeholder:
                                                  slotProps.getSourceValue(
                                                    column
                                                  ) || "属性" + column.attrId,
                                              },
                                              domProps: {
                                                value:
                                                  _vm.getSkuAttrHeaderDraftValue(
                                                    column,
                                                    _vm.asSourceSlot(slotProps)
                                                  ),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                },
                                                keydown: function ($event) {
                                                  $event.stopPropagation()
                                                },
                                                input: function ($event) {
                                                  _vm.handleSkuAttrHeaderDraftInput(
                                                    column,
                                                    _vm.asSourceSlot(slotProps),
                                                    $event.target.value
                                                  )
                                                },
                                                blur: function ($event) {
                                                  _vm.commitSkuAttrHeaderDraft(
                                                    column,
                                                    _vm.asSourceSlot(slotProps)
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(
                                  _vm.getSkuValueFieldItems(
                                    slotProps.fieldItems
                                  ),
                                  function (row) {
                                    return _c(
                                      "tr",
                                      { key: "left_sku_row_" + row.fieldKey },
                                      [
                                        _c("td", [_vm._v(_vm._s(row.skuId))]),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.getSkuAttrNameFieldItems(
                                            slotProps.fieldItems
                                          ),
                                          function (column) {
                                            return _c(
                                              "td",
                                              {
                                                key:
                                                  "left_sku_cell_" +
                                                  row.fieldKey +
                                                  "_" +
                                                  column.fieldKey,
                                              },
                                              [
                                                _c("textarea", {
                                                  staticClass:
                                                    "sku-cell-textarea",
                                                  attrs: {
                                                    placeholder:
                                                      "请输入" +
                                                      slotProps.defaultLangName,
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.getSkuSegmentByIndex(
                                                        row,
                                                        column.attrIndex,
                                                        _vm.asSourceSlot(
                                                          slotProps
                                                        ),
                                                        true
                                                      ),
                                                  },
                                                  on: {
                                                    focus: function ($event) {
                                                      _vm.handleSkuFocus(
                                                        row,
                                                        _vm.asSourceSlot(
                                                          slotProps
                                                        )
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      _vm.handleSkuSegmentInput(
                                                        row,
                                                        column.attrIndex,
                                                        $event.target.value,
                                                        _vm.asSourceSlot(
                                                          slotProps
                                                        )
                                                      )
                                                    },
                                                    blur: function ($event) {
                                                      _vm.handleSkuBlur(
                                                        row,
                                                        _vm.asSourceSlot(
                                                          slotProps
                                                        )
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(
                      _vm.getRichFieldItems(slotProps.fieldItems),
                      function (item) {
                        return _c(
                          "el-form-item",
                          {
                            key: "left_rich_" + item.fieldKey,
                            attrs: { label: item.fieldLabel + "：" },
                          },
                          [
                            _vm.showEditor(_vm.asSourceSlot(slotProps))
                              ? _c("Tinymce", {
                                  key: _vm.getEditorKey(
                                    item.fieldKey,
                                    slotProps.sourceLangCode
                                  ),
                                  attrs: {
                                    id: _vm.getEditorId(
                                      item.fieldKey,
                                      slotProps.sourceLangCode
                                    ),
                                    value: slotProps.getSourceValue(item),
                                    height: 320,
                                    toolbar: _vm.editorToolbar,
                                    menubar: "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return slotProps.setSourceValue(
                                        item.fieldKey,
                                        $event
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      }
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        },
      },
      {
        key: "right",
        fn: function (slotProps) {
          return [
            _c(
              "div",
              [
                _c("div", { staticClass: "panel-title" }, [
                  _vm._v(_vm._s(slotProps.currentLangName) + "翻译"),
                ]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    staticClass: "formValidate",
                    attrs: { "label-width": "110px" },
                  },
                  [
                    _vm._l(
                      _vm.getNormalFormFieldItems(slotProps.fieldItems),
                      function (item) {
                        return _c(
                          "el-form-item",
                          {
                            key: "right_" + item.fieldKey,
                            attrs: { label: item.fieldLabel + "：" },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                value: slotProps.getCurrentValue(item.fieldKey),
                                type: "textarea",
                                rows: 2,
                                placeholder:
                                  "请输入" + slotProps.currentLangName + "翻译",
                              },
                              on: {
                                input: function ($event) {
                                  return slotProps.setCurrentValue(
                                    item.fieldKey,
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        )
                      }
                    ),
                    _vm._v(" "),
                    _vm.getSkuValueFieldItems(slotProps.fieldItems).length
                      ? _c("el-form-item", { attrs: { label: "SKU规格：" } }, [
                          _c("div", { staticClass: "sku-native-wrap" }, [
                            _c("table", { staticClass: "sku-native-table" }, [
                              _c("thead", [
                                _c(
                                  "tr",
                                  [
                                    _c("th", [_vm._v("SKU ID")]),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.getSkuAttrNameFieldItems(
                                        slotProps.fieldItems
                                      ),
                                      function (column) {
                                        return _c(
                                          "th",
                                          {
                                            key:
                                              "right_sku_col_" +
                                              column.fieldKey,
                                          },
                                          [
                                            _c("input", {
                                              staticClass: "sku-header-input",
                                              attrs: {
                                                placeholder:
                                                  slotProps.getSourceValue(
                                                    column
                                                  ) || "属性" + column.attrId,
                                              },
                                              domProps: {
                                                value:
                                                  _vm.getSkuAttrHeaderDraftValue(
                                                    column,
                                                    slotProps
                                                  ),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                },
                                                keydown: function ($event) {
                                                  $event.stopPropagation()
                                                },
                                                input: function ($event) {
                                                  return _vm.handleSkuAttrHeaderDraftInput(
                                                    column,
                                                    slotProps,
                                                    $event.target.value
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.commitSkuAttrHeaderDraft(
                                                    column,
                                                    slotProps
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(
                                  _vm.getSkuValueFieldItems(
                                    slotProps.fieldItems
                                  ),
                                  function (row) {
                                    return _c(
                                      "tr",
                                      { key: "right_sku_row_" + row.fieldKey },
                                      [
                                        _c("td", [_vm._v(_vm._s(row.skuId))]),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.getSkuAttrNameFieldItems(
                                            slotProps.fieldItems
                                          ),
                                          function (column) {
                                            return _c(
                                              "td",
                                              {
                                                key:
                                                  "right_sku_cell_" +
                                                  row.fieldKey +
                                                  "_" +
                                                  column.fieldKey,
                                              },
                                              [
                                                _c("textarea", {
                                                  staticClass:
                                                    "sku-cell-textarea",
                                                  attrs: {
                                                    placeholder:
                                                      "请输入" +
                                                      slotProps.currentLangName +
                                                      "翻译",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.getSkuSegmentByIndex(
                                                        row,
                                                        column.attrIndex,
                                                        slotProps,
                                                        true
                                                      ),
                                                  },
                                                  on: {
                                                    focus: function ($event) {
                                                      return _vm.handleSkuFocus(
                                                        row,
                                                        slotProps
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      return _vm.handleSkuSegmentInput(
                                                        row,
                                                        column.attrIndex,
                                                        $event.target.value,
                                                        slotProps
                                                      )
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.handleSkuBlur(
                                                        row,
                                                        slotProps
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(
                      _vm.getRichFieldItems(slotProps.fieldItems),
                      function (item) {
                        return _c(
                          "el-form-item",
                          {
                            key: "right_rich_" + item.fieldKey,
                            attrs: { label: item.fieldLabel + "：" },
                          },
                          [
                            _vm.showEditor(slotProps)
                              ? _c("Tinymce", {
                                  key: _vm.getEditorKey(
                                    item.fieldKey,
                                    slotProps.activeLangCode
                                  ),
                                  attrs: {
                                    id: _vm.getEditorId(
                                      item.fieldKey,
                                      slotProps.activeLangCode
                                    ),
                                    value: slotProps.getCurrentValue(
                                      item.fieldKey
                                    ),
                                    height: 320,
                                    toolbar: _vm.editorToolbar,
                                    menubar: "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return slotProps.setCurrentValue(
                                        item.fieldKey,
                                        $event
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      }
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }